import { DropdownNode } from "@/components/ActionDropdown";
import { NavigateFunction } from "react-router-dom";

/**
 * User profile dropdown menu configuration.
 * Pure factory function — no hooks allowed here.
 * @param navigate - from useNavigate() in the calling component
 * @param logout   - from useAuthStore() in the calling component
 */
export const createUserProfileConfig = (
  navigate: NavigateFunction,
  logout: () => void
): DropdownNode[] => {
  return [
    {
      type: "item",
      label: "Profile",
      onSelect: () => {
        navigate("/profile");
      },
    },
    {
      type: "item",
      label: "Settings",
      onSelect: () => {
        navigate("/settings");
      },
    },
    {
      type: "separator",
    },
    {
      type: "item",
      label: "Logout",
      className: "text-destructive focus:text-destructive",
      onSelect: () => {
        logout();
      },
    },
  ];
};
